import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

import { MODALS, INFLUENCER_PREVIEW_URL } from 'global-constants';

import WithUser from 'shared/HOCs/WithUser';
import { fetchMe } from 'shared/HOCs/FetchInitials/ducks/index.js';

import { substituteUrl } from 'shared/utils/substituteUrl';

import Image from 'shared/components/Image';
import { openModal } from 'shared/components/Modals/reducer';
import ConnectButton from 'shared/components/ConnectButton';
import MessageButton from 'shared/components/MessageButton';
import {
  getInfluencerFullName,
  getInfluencerOccupation
} from 'shared/utils/influencer';
import ordinalNumber from 'shared/utils/ordinalNumber';

import { roundNumber } from 'shared/utils/roundNumber';

import defaultAvatar from 'assets/images/default-avatar.png';

import styles from './styles.module.scss';

class InfluencerBox extends Component {
  handleUnsignedMessageClick = () => {
    if (_.isEmpty(this.props.user))
      this.props.openModal({ modalName: MODALS.SIGNUP });
  };

  getRedirectLink = () => {
    const { influencer } = this.props;

    return substituteUrl(INFLUENCER_PREVIEW_URL, {
      influencerSlug: influencer.slug
    });
  };

  render() {
    const { user, influencer, wrapperClassname } = this.props;
    let rank = _.isNil(influencer.rank) ? '-' : ordinalNumber(influencer.rank);
    if (_.startsWith(influencer.computed_rank, '=')) {
      rank = '=' + rank;
    }

    const redirectLink = this.getRedirectLink();

    return (
      <div className={classnames(styles.boxWrapper, wrapperClassname)}>
        <div className={styles.data}>
          <Link
            to={redirectLink}
            onClick={
              !_.isNil(this.props.getRedirectLink)
                ? () => {}
                : this.props.redirectToInfluencer
            }
            className={styles.image}>
            <Image
              src={influencer.profile.avatar}
              thumbnails={influencer.profile.thumbnails}
              defaultImage={defaultAvatar}
              width={75}
              height={75}
            />
          </Link>
          <div className={styles.info}>
            <Link
              to={redirectLink}
              onClick={
                !_.isNil(this.props.getRedirectLink)
                  ? () => {}
                  : this.props.redirectToInfluencer
              }
              className={styles.name}>
              <h4>{getInfluencerFullName(influencer)}</h4>
            </Link>
            <div className={styles.occupation}>
              {getInfluencerOccupation(influencer)}
            </div>
            <div className={styles.actionsWrapper}>
              {_.get(user, 'id') !== influencer.id && (
                <React.Fragment>
                  <MessageButton
                    handleUnsigned={this.handleUnsignedMessageClick}
                    target={influencer}
                  />

                  <ConnectButton
                    className={styles.connect}
                    influencer={influencer}
                    connected={influencer.connected}
                    small={true}
                  />
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        <div className={styles.stats}>
          <div>
            <div className={styles.stat}>
              {roundNumber(influencer.connection_count)}
            </div>
            <div className={styles.statName}>Connections</div>
          </div>
          <div>
            <div className={styles.stat}>{influencer.contribution_count}</div>
            <div className={styles.statName}>Contributions</div>
          </div>
          <div>
            <div className={styles.stat}>
              {influencer.index ? ordinalNumber(influencer.index) : rank}
            </div>
            <div className={styles.statName}>
              {!influencer.index && 'Overall '}Rank
            </div>
          </div>
        </div>
        {influencer.index && (
          <div className={styles.allTimesRankWrapper}>
            <div className={styles.rank}>ALL TIME RANK: {rank}</div>
          </div>
        )}
      </div>
    );
  }
}

const Placeholder = ({ count = 1, wrapperClassname }) =>
  _.range(count).map(index => (
    <div
      className={classnames(styles.boxWrapper, wrapperClassname)}
      key={`influencer-box-placeholder-${index}`}>
      <div className={styles.data}>
        <div className={styles.image}>
          <Skeleton width={75} height={75} />
        </div>
        <div className={styles.info}>
          <h4 className={styles.name}>
            <Skeleton width={125} />
          </h4>
          <div className={styles.occupation}>
            <Skeleton width={100} />
          </div>
        </div>
      </div>
      <div className={styles.stats}>
        <div>
          <div className={styles.stat}>
            <Skeleton />
          </div>
          <div className={styles.statName}>Connections</div>
        </div>
        <div>
          <div className={styles.stat}>
            <Skeleton />
          </div>
          <div className={styles.statName}>Contributions</div>
        </div>
        <div>
          <div className={styles.stat}>
            <Skeleton />
          </div>
          <div className={styles.statName}>Rank</div>
        </div>
      </div>
      <div className={styles.allTimesRankWrapper}>
        <div className={styles.rank}>
          ALL TIME RANK: =<Skeleton width={20} />
        </div>
      </div>
    </div>
  ));

InfluencerBox = WithUser(
  connect(
    null,
    { openModal, fetchMe }
  )(InfluencerBox)
);
InfluencerBox.Placeholder = Placeholder;

export default InfluencerBox;
